<template>
  <div>
    <v-menu location="bottom">
      <template #activator="{ props }">
        <div class="pa-1" v-bind="props">
          <c-icon size="24" name="$user-gear" color="black" />
        </div>
      </template>
      <v-list density="compact" class="dropdown-list">
        <v-list-item v-if="adNetworkHasSectionProfile" :to="{ name: routeNames.PERSONAL }">
          <template #prepend>
            <c-icon size="20" name="$gear" color="secondary-600" />
          </template>
          <v-list-item-title class="name text-subtitle-2"> {{ user.name }} </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="$vuetify.display.xs" @click="redirectAddFunds()">
          <template #prepend>
            <c-icon size="20" name="$credit-card" color="secondary-600" />
          </template>
          <v-list-item-title>
            {{ balance }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="$vuetify.display.xs && adNetworkHasSectionAddFunds"
          class="bg-primary"
          @click="$router.push({ name: routeNames.ADD_FUNDS })"
        >
          <template #prepend>
            <v-icon color="white" size="18"> $credit-card-plus </v-icon>
          </template>
          <v-list-item-title class="text-white text-subtitle-2">
            {{ $t('main.sidebar.add_funds') }}
          </v-list-item-title>
        </v-list-item>

        <v-divider v-if="adNetworkHasSectionProfile" />

        <v-list-item :to="{ name: routeNames.LOGOUT }">
          <template #prepend>
            <c-icon size="20" name="$log-out" color="secondary-600" />
          </template>
          <v-list-item-title class="text-subtitle-2">
            {{ isImpersonating ? 'Leave impersonate' : $t('main.exit') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { toFixedByDefault } from '@clickadilla/components/utils'
  import { CIcon } from '@clickadilla/components/components'
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'
  import guardSections from '@/types/guard-sections'
  import routeNames from '@/types/route-names'

  export default {
    name: 'DropdownMenu',
    components: { CIcon },
    data() {
      return {
        routeNames
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['adNetwork']),
      user() {
        return this.$auth.user || {}
      },
      balance() {
        if (!this.user) {
          return '-'
        }
        const prefix = this.adNetwork.settings.currencySignIsShown ? '$' : ''
        return `${prefix} ${toFixedByDefault(this.user.balance)}`
      },
      isImpersonating() {
        return !!this.user.is_impersonating
      },
      adNetworkHasSectionAddFunds() {
        return this.adNetwork.guardSections.some(({ name }) => name === guardSections.ADD_FUNDS)
      },
      adNetworkHasSectionProfile() {
        return this.adNetwork.guardSections.some(({ name }) => name === guardSections.PROFILE)
      }
    },
    methods: {
      redirectAddFunds() {
        if (this.adNetworkHasSectionAddFunds) {
          this.$router.push({ name: routeNames.ADD_FUNDS })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dropdown-list {
    --v-list-prepend-gap: 8px;
  }
  .name {
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    max-width: 300px;
  }
</style>
